import { Controller } from "@hotwired/stimulus"
import "@selectize/selectize"

export default class extends Controller {
  static get targets() {
    return [
      "departmentFilterStrength", "roleFilterStrength", "departmentsFilter", "requiredFieldsFilter", "select",
      "preserveFile", "fileInput", "companyRadio", "domainRadio", "domainsTextarea"
    ];
  }

  // Instantiates selectize on select fields that are targeted
  // when the page loads
  connect() {
    this.select = $(this.selectTarget).selectize({
      plugins: ['remove_button'],
      persist: false,
      create: false,
    })[0].selectize

    this.requiredFieldsSelectize = $(this.requiredFieldsFilterTarget).selectize({
      plugins: ['remove_button'],
      persist: false,
      create: false,
    })[0].selectize

    this.changePlaceholder()
  }

  disconnect() {
    // Destroy the Selectize element to avoid duplication of the field
    this.requiredFieldsSelectize.destroy()
    this.select.destroy()
  }

  // Displays the department filter selectize when the user selects
  // the "the following departments" option in the select field
  toggleDepartmentFilter(e) {
    if (e.target.options[e.target.selectedIndex].value === "all_departments") {
      this.departmentsFilterTarget.classList.add("d-none")
      this.select.setValue("")
    } else {
      this.departmentsFilterTarget.classList.remove("d-none")
      this.select.setValue("executive")
    }
  }

  toggleDepartmentFilterStrengthVisibility(e) {
    if (e.target.options[e.target.selectedIndex].value === "all_departments") {
      this.departmentFilterStrengthTarget.classList.add("d-none")
    }
    else {
      this.departmentFilterStrengthTarget.classList.remove("d-none")
    }
  }

  toggleRoleFilterStrengthVisibility(e) {
    if (e.target.options[e.target.selectedIndex].value == "generic_and_personal") {
      this.roleFilterStrengthTarget.classList.add("d-none")
    }
    else {
      this.roleFilterStrengthTarget.classList.remove("d-none")
    }
  }

  selectFile() {
    const file = this.fileInputTarget.files[0];

    if (file && file.type === 'text/csv') {
      // Enable the preserve file checkbox since the user has selected a CSV file
      this.preserveFileTarget.disabled = false;
      this.preserveFileTarget.classList.remove("disabled")
    } else {
      // Disable the preserve file checkbox since the user has selected a non-CSV file or removed the file
      this.preserveFileTarget.disabled = true;
      this.preserveFileTarget.checked = false;
      this.preserveFileTarget.classList.add("disabled")
    }
  }

  changePlaceholder() {
    let placeholder = ""

    if (this.domainRadioTarget.checked) {
      placeholder = (!App.browserIsFirefox && App.browserIsSafari) ? "hubspot.com" : "hubspot.com\nsalesforce.com\n..."
      this.domainsTextareaTarget.setAttribute("placeholder", placeholder)
    } else if (this.companyRadioTarget.checked) {
      placeholder = (!App.browserIsFirefox && App.browserIsSafari) ? "HubSpot" : "HubSpot\nSalesforce\n..."
      this.domainsTextareaTarget.setAttribute("placeholder", placeholder)
    }
  }
}
